/* 劉備傳・第 5 章：隆中（207 年）
 * 西邊是劉備屯兵的新野，東邊山裡是隆中，諸葛亮的草廬在竹林邊，門前有一片空地。 */
export const XINYE = [900, 2400], HUT = [6600, 2100], DOOR = [6600, 2330];
export default {
  id: 'longzhong', name: '隆中', W: 7600, H: 4400, seed: 207,
  bases: [XINYE, HUT],
  roads: [{ pts: [XINYE, [2400, 2500], [3800, 2300], [5200, 2500], [6000, 2400], DOOR], w: 120 }],
  rocks: [[3000, 1200, 420, 200], [4600, 3500, 420, 200], [6300, 1200, 380, 180], [7100, 3200, 300, 160]],
  woods: 0.55,
  sight: 1,
  clearings: [[XINYE[0], XINYE[1], 500], [HUT[0], HUT[1] + 200, 420], [HUT[0], HUT[1] + 460, 460], [3800, 2300, 300]],
  villages: [{ x: XINYE[0], y: XINYE[1], n: 6, r: 400 }, { x: 5300, y: 2900, n: 4, r: 300 }],
  fields: [[5600, 2900, 520, 260], [2400, 3200, 520, 260, '#86803f']],
  tents: [{ x: XINYE[0] - 100, y: XINYE[1] - 300, n: 4, r: 260, col: '#3e7b50', flag: '劉' }],
};
